const PREFIX = 'NAV';

export const SET_URL_FILTERS = `${PREFIX}/URL_FILTERS_SET`;
export const UPDATE_URL_FILTERS = `${PREFIX}/URL_FILTERS_LOAD`;
